// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1941":"e7dab7bd","6063":"e7dab7bd"}[chunkId] + ".chunk.css";
};